<div class="reservation-container">
    <div class="reservation-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/shield_check_red.png" alt="shield_check_red Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Detail de réservations</span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>
    <div class="reservation-details-container">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des détails du réservation...</p>
        </div>

        <!-- Error state -->
        <div *ngIf="!isLoading && errorMessage" class="error-state">
            <div class="error-icon">!</div>
            <p class="error-message">{{ errorMessage }}</p>
            <button class="btn-primary" (click)="goToList()">Retour à la liste</button>
        </div>

        <div *ngIf="!isLoading && reservation && !errorMessage" class="reservation-card-container">
            <div class="reservation-card-container">

                <!-- Reservation Card -->
                <div class="reservation-card">
                    <div class="reservation-image-col">
                        <img [src]="'./assets/images/icons/file_check_card.png'" [alt]="reservation.eventName" class="reservation-image">
                    </div>

                    <div class="reservation-content-col">
                        <div class="col-header">
                            <h3 class="reservation-title">
                                <strong>{{ reservation.eventName }}</strong> / {{ reservation.client.firstName +" "+ reservation.client.lastName }}
                            </h3>
                            <div class="right-side">
                                <div class="status-badge">
                                    <span class="status-dot" [ngClass]="getReservationAdminStatusClass()"></span>
                                    <span class="status-text">{{ getReservationAdminStatusText() }}</span>
                                </div>

                                <!-- Reservation Header with Actions -->
                                <div class="reservation-header-actions" *ngIf="reservationActionState">
                                    <div class="action-buttons" *ngIf="!isPerformingAction">
                                        @if(reservation.offers){
                                        <!--<button *ngIf="reservationActionState?.canAcceptOffer" class="action-btn accept-btn" [title]="getActionButtonText('accept')" (click)="acceptOffer()">
                                            <img src="./assets/images/icons/check-circle.svg" alt="Accept">
                                            <span>{{ getActionButtonText('accept') }}</span>
                                        </button>

                                        <button *ngIf="reservationActionState?.canRejectOffer" class="action-btn reject-btn" [title]="getActionButtonText('reject')" (click)="rejectOffer()">
                                            <img src="./assets/images/icons/x-circle.svg" alt="Reject">
                                            <span>{{ getActionButtonText('reject') }}</span>
                                        </button>-->
                                        <button *ngIf="reservationActionState?.canRequestNewOffer" class="action-btn request-new-btn" [title]="getActionButtonText('request_new')" (click)="requestNewOffer()">
                                            <span>{{ getActionButtonText('request_new') }}</span>
                                        </button> }
                                        <!-- Update Reservation Button -->
                                        <button *ngIf="reservationActionState?.canUpdateReservation" class="action-btn update-btn" [title]="getActionButtonText('update')" (click)="updateReservation()">
                                            <img src="./assets/images/icons/edit.png" alt="Edit">
                                            <span>{{ getActionButtonText('update') }}</span>
                                        </button>
                                    </div>

                                    <!-- Loading indicator -->
                                    <div class="loading-indicator" *ngIf="isPerformingAction">
                                        <div class="spinner"></div>
                                        <span>{{ getLoadingText() }}</span>
                                    </div>
                                </div>

                                <!-- Menu button for additional actions -->
                                <div class="menu-container" *ngIf="reservationActionState.canSeeFeedbackDetails || reservationActionState.canGiveFeedback || reservationActionState?.canCancelReservation || reservationActionState?.canDeleteReservation">
                                    <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                                        <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                                    </button>

                                    <!-- Dropdown menu -->
                                    <div class="popup-menu" *ngIf="menuOpen">
                                        <div class="arrow"></div>
                                        <ul>
                                            <li *ngIf="reservation.serviceFeedbackId && reservationActionState.canSeeFeedbackDetails" class="menu-item cancel-item" (click)="feedbackDetails()">
                                                <img src="./assets/images/icons/eye.png" alt="feedback details">
                                                <span>Voir mon avis</span>
                                            </li>
                                            <li *ngIf="reservationActionState.canGiveFeedback" class="menu-item cancel-item" (click)="giveFeedback()">
                                                <svg class="star-icon" viewBox="0 0 24 24">
                                                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                                                </svg>
                                                <span>{{ reservation.serviceFeedbackId ? 'Modifier mon avis' : 'Évaluer le service' }}</span>
                                            </li>
                                            <!-- Cancel Reservation -->
                                            <li *ngIf="reservationActionState?.canCancelReservation" class="menu-item cancel-item" (click)="cancelReservation()">
                                                <img src="./assets/images/icons/x.svg" alt="Cancel">
                                                <span>{{ getActionButtonText('cancel') }}</span>
                                            </li>

                                            <!-- Delete Reservation -->
                                            <li *ngIf="reservationActionState?.canDeleteReservation" class="menu-item delete-item" (click)="deleteReservation()">
                                                <img src="./assets/images/icons/trash.png" alt="Delete">
                                                <span>{{ getActionButtonText('delete') }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="reservation-footer">
                            <div class="info-col">
                                <div>
                                    <div class="data" title="Nombre d'agents requis">
                                        <img src="./assets/images/icons/user_card_id_gray.png" alt="user_card_id icon">
                                        <span><strong>Nombre d'agents requis : </strong> {{ reservation.requiredAgents }}</span>
                                    </div>
                                    <div class="data" title="Date d'événment">
                                        <img src="./assets/images/icons/calendar_calendar_event_gray.png" alt="calendar_calendar_event_gray icon">
                                        <span><strong>Date d'événement : </strong> {{ reservation.startDateTime }} @if(reservation.endDateTime){- {{ reservation.endDateTime }} }</span>
                                    </div>
                                    <div class="data">
                                        <img src="./assets/images/icons/map_pin_gray.png" alt="map_pin_gray icon">
                                        <span><strong>Address d'événement : </strong> {{ formatAddress(reservation.address) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="creation-date" title="Date de creation">
                                {{ reservation.createdAt }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Description Card -->
                <div class="description-card">
                    <h1>Note</h1>
                    <p>{{reservation.description || 'Aucune note'}}</p>
                </div>

                <!-- Offers Card -->
                <div class="offers-card">
                    <div class="offers-card-header">
                        <h1>
                            <img src="./assets/images/icons/suitcase.png" alt="suitcase">
                            <span>Offres <strong *ngIf="reservation.offers">({{ reservation.offers.length || '0' }})</strong></span>
                        </h1>
                    </div>

                    <!-- Empty state -->
                    <div *ngIf="!reservation.offers || (reservation.offers && reservation.offers.length === 0)" class="empty-offer-state">
                        <p>Aucune proposition en cours.</p>
                    </div>

                    <!-- Offers list -->
                    <div *ngIf="reservation.offers && reservation.offers.length > 0" class="offers-list">
                        <app-member-reservation-offer-card *ngFor="let offer of offersWithActions" [offer]="offer" [reservationId]="reservation.id" (offerAccepted)="onOfferAccepted()" (offerRejected)="onOfferRejected()">
                        </app-member-reservation-offer-card>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer cette réservation ? </p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmDeleteReservation()">Supprimer</button>
        </div>
    </div>
</div>

<!-- Cancel Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showCancelModal" (click)="closeCancelModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer l'annulation</h3>
            <button class="close-button" (click)="closeCancelModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir annuler cette réservation ?</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeCancelModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmCancelReservation()">Annuler la réservation</button>
        </div>
    </div>
</div>

<!-- Reject Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showRejectModal" (click)="closeRejectModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer le refus</h3>
            <button class="close-button" (click)="closeRejectModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir refuser cette offre ?</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeRejectModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmRejectOffer()">Refuser l'offre</button>
        </div>
    </div>
</div>